require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /var/www/24tru/releases/20230713222349/htdocs-rails/node_modules/core-js/modules/es6.array.species.js
// module id = 2221
// module chunks = 16